import useBaseIndex from "../../base/hooks/useBaseIndex";
import { HousekeepingResponseSchema } from "../response/HousekeepingReportResponse";

const API_VERSION = "v3";

interface Props {
    filters?: { [key: string]: any };
    search?: string;
    paginate?: number;
    page?: number;
    [key: string]: any;
}

const useHousekeepingReport = (query: Props) =>
    useBaseIndex({
        ...query,
        queryKey: "housekeeping-report",
        endpoint: `${API_VERSION}/housekeeping-report`,
        schema: HousekeepingResponseSchema,
    });

export default useHousekeepingReport;